import axios from 'axios'
import { Decode } from '@/services'

const GetToken = () => {
  if (Object.prototype.hasOwnProperty.call(localStorage, 'oneData')) {
    const oneData = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
    // console.log('ONEDATA NAAAa', oneData)
    const auth = {
      headers: { Authorization: `Bearer ${oneData.user.access_token}` }
    }
    return auth
  }
}

export default {
  async GetSellerShop () {
    const auth = await GetToken()
    try {
      var response = await axios.get(`${process.env.VUE_APP_BACK_END}api/get_shop_detail`, auth)
      // console.log('response.data', response.data)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async PostRegisterbuyer (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/register_business_moph_commerce`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ConfirmOTPOneID (val) {
    // const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/oauth_otp`, val)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetBizDetail (val) {
    const auth = await GetToken()
    try {
      var response = await axios.get(`${process.env.VUE_APP_BACK_END2}users/get_diz_detail`, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async LoginUsername (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/login_web`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async RegisterLineOA (val, uuid) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}seller/line/register/${uuid}`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async LoginUsernameTestOneID (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/login_test`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetOTP (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/get_otp_oauth_v2`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ConfirmGetOTP (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/confirm_otp_oauth_v2`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async VerifyOTP (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/users/verify_otp`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async LoginMobileAndIdcard (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/login_mobile_and_idcard`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ButtonCheckStatus (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/button_check_status`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }
}
